// ######################### Finding Render Method #########################
// Affects the way we render findings
// flat = findings are rendered flat as a variable value pair.
// scale = finding of type numeric will attempt to render as a scale so long as the value the variable is
// connected to is of type "standard-range", otherwise will default to flat.
export const findingRenderMethod_Flat = 'flat';
export const findingRenderMethod_Scale = 'scale';
export const findingRenderMethods = [findingRenderMethod_Flat, findingRenderMethod_Scale];
//# sourceMappingURL=types.js.map